import { FC } from "react";

import LokasiIntelligenceBvartaLogo from "@/assets/svg/lokasiIntelligenceBvartaLogo.svg?react";

type Props = {
  heading: string;
  description: string;
};

const AgenticAIWelcome: FC<Props> = ({ heading, description }) => (
  <div className="flex flex-col items-center text-center">
    <LokasiIntelligenceBvartaLogo
      title="LOKASI Intelligence Bvarta Logo"
      className="mb-6 h-auto w-[38px]"
    />
    <h1 className="text-[2rem] font-bold text-txtHeading">{heading}</h1>
    <p className="mt-3 text-xl text-txtBody">{description}</p>
  </div>
);

export default AgenticAIWelcome;
